import { useQuery } from 'react-query';
import { api } from '../api';
import { customSort } from '../../utils/SortExtractData';

export interface IExtractProps {
  id: string;
  indice: number;
  referencia: string;
  idComprovante: string;
  dtMovimento: string;
  tipo: string;
  vlMovimento: number;
  saldoAcumulado: number;
};

interface IParams {
  docto: string;
  dtInicial: string | undefined;
  dtFinal: string | undefined;
}

interface GetContaPagamentoResult {
  extrato: IExtractProps[];
  saldoInicial: number;
  saldoFinal: number;
}

export async function getContaPagamento(
  params: IParams
): Promise<GetContaPagamentoResult> {
  const { data } = await api.get('transactions/extrato', {
    params
  });

  return {
    extrato: data.extrato.sort(customSort),
    saldoInicial: data.saldoInicial,
    saldoFinal: data.saldoFinal
  }
}

export function useContaPagamento(params: IParams) {
  return useQuery(
    [
      'contaPagamento',
      params.docto,
      params.dtInicial,
      params.dtFinal,
    ],
    () => getContaPagamento({ ...params }),
    {
      staleTime: Infinity,
      enabled: String(api.defaults.headers.common.authorization).length > 10 && !!params.docto,
      retry: 2
    }
  );
}
